import React from 'react';
import {Container, Row, Col, Image} from 'react-bootstrap';


const AdvertiseWithUs = () => {
  return (
    <section className="sp-cnt-blk">
      <Container>
        <div className='sp-cnt-in advertise text-center'>
          <div className='sp-cnt-in2'>
            <div class="vertical-badge lft">
              <span>We Accept Digital Payments Only</span>
            </div>       
            <div class="vertical-badge rt">
              <span>We Accept Cashless  Payments Only</span>
            </div>
          <div className='hdg'><figure><Image src={`${process.env.PUBLIC_URL}/images/advertise-hdg.png`} fluid /></figure></div>
          <Row>
            <div className="item-bx">
                <figure><Image src={`${process.env.PUBLIC_URL}/images/hoarding.png`} fluid /></figure>
                <p>Hoarding</p>
            </div>
            <div className="item-bx">
                <figure><Image src={`${process.env.PUBLIC_URL}/images/cutouts.png`} fluid /></figure>
                <p>Cutouts</p>
            </div>
            <div className="item-bx">
                <figure><Image src={`${process.env.PUBLIC_URL}/images/banners.png`} fluid /></figure>
                <p>Banners</p>
            </div>
            <div className="item-bx">
                <figure><Image src={`${process.env.PUBLIC_URL}/images/posters.png`} fluid /></figure>
                <p>Posters</p>
            </div>
            <div className="item-bx">
                <figure><Image src={`${process.env.PUBLIC_URL}/images/stall.png`} fluid /></figure>
                <p>Stall</p>
            </div>
            <div className="item-bx">
                <figure><Image src={`${process.env.PUBLIC_URL}/images/pamphlets.png`} fluid /></figure>
                <p>Pamphlets Distribution</p>
            </div>
            <div className="item-bx">
                <figure><Image src={`${process.env.PUBLIC_URL}/images/sponsored-panel.png`} fluid /></figure>
                <p>Sponsored panel on our website</p>
            </div>
            <div className="item-bx">
                <figure><Image src={`${process.env.PUBLIC_URL}/images/coupons.png`} fluid /></figure>
                <p>On Our Disposals, Uniforms &amp; Also On Guest Entry Coupons.</p>
            </div>
        </Row>
          <Row>
            <div className="contact-wrap">
              <div className='whatsapp-blk'>
                <p>For more updates please</p>             
                  <div className='btn-whatsapp'><a href='https://wa.me/9884334346' target='_blank'><Image src={`${process.env.PUBLIC_URL}/images/ic-whatsapp.png`} fluid /> 9884334346</a></div>
              </div>
            </div>
          </Row>
          </div>
        </div>
      </Container>
    </section>      
  )
}

export default AdvertiseWithUs